import React from 'react';

const Star = ({ className = '' }) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.39376 1.10505C4.61776 0.566547 5.38176 0.566547 5.60576 1.10505L6.64676 3.60855L9.34876 3.82505C9.93076 3.87155 10.1668 4.59755 9.72326 4.97755L7.66476 6.74105L8.29326 9.37755C8.42876 9.94555 7.81126 10.394 7.31326 10.09L4.99976 8.67705L2.68626 10.09C2.18826 10.394 1.57076 9.94505 1.70626 9.37755L2.33476 6.74105L0.276257 4.97755C-0.167243 4.59755 0.0687571 3.87155 0.650757 3.82505L3.35276 3.60855L4.39376 1.10505Z"
        fill="white"
      />
    </svg>
  );
};

export default Star;
